import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ltx/phase-i/lab-procedures/standard-lab-procedures/ggt";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	ggt: {
		id: "form.ggt",
		defaultMessage: "GGT"
	},
	value: {
		id: "form.ggt.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ggt",
	value: {
		title: messages.ggt,
		validator,
		fieldset,
		isImportant: true
	}
};
